import { Button, ButtonProps, CircularProgress } from '@mui/material';
import React from 'react';

type LoadingButtonProps = ButtonProps & {
    /** While true the button is disabled and shows a spinner in place of its start icon. */
    loading?: boolean;
};

/** A Button that can't be pressed again while its action runs, and says so with a spinner. */
export function LoadingButton({
    loading = false,
    disabled,
    startIcon,
    children,
    ...rest
}: LoadingButtonProps) {
    return (
        <Button
            {...rest}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            startIcon={
                loading ? (
                    <CircularProgress size={16} color="inherit" aria-label="Loading" />
                ) : (
                    startIcon
                )
            }
        >
            {children}
        </Button>
    );
}
